import { ReactElement } from 'react'
import illustration from '../images/Padasjoki2.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Jätän ystäväni huomiotta ja menen päiväunille',
    gotoStage: 0
  },
  {
    text: 'Mennään hyppimään heinäsuovassa, vaikka äiti on kieltänyt sen',
    gotoStage: 0
  },
  {
    text: 'Mennään rakentamaan pato',
    gotoStage: 3
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const PadasjokiStage2 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle small>Mainiemen lapset</StageTitle>
      <StageText>
        Juokset niin nopeasti kuin pystyt. Tunnet tuulen kasvoillasi ja hengityksesi alkaa käymään raskaaksi. Toiset pienet askeleet kuuluvat takaasi, sinua jahdataan. Vauhtisi hidastuu ja pieni käsi hipaisee selkääsi: ”Hippa!”. ”Eikä!” tuhahdat. Kääntyessäsi ympäri näet toisen kaverisi juoksevan lähelläsi - nyt on mahdollisuutesi iskeä. Loikkaat jälleen vauhtiin ja saavutat pikkuhiljaa ystävääsi. ”Hippa!” huudat ja jäät naureskelemaan paikallesi. Sitten pilli vislaa taas, kello on 12. Lapset kerääntyvät yhteen ja aikuiset tulevat paikalle omista askareistaan. ”Sitten syömään mukulat”, eräs isä kaappaa levottomasti hykertelevät lapset mukaansa syömään.
      </StageText>
      <StageText>
        Ruoan jälkeen on uusien metkujen aika. Jos olisi kylmä talvi kaivautuisit kaverisi kanssa sahanpurujen sekaan lämmittelemään, mutta alkusyksyn aurinko vielä lämmittää mukavasti. ”Hei mennäänkö rakentamaan pato?” ystäväsi ehdottaa sinulle. Yhtaikaa kaksi tyttöä juoksevat ohitsenne ja viittovat sinua ja ystävääsi lähtemään heidän mukaansa hyppimään heinäsuopaan. Ystäväsi kääntyy puoleesi kysyvän näköisenä. ”Vai pitäisikö meidän liittyä noiden seuraan?”
      </StageText>
      <StageText>
        <strong>Mitä vastaat?</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default PadasjokiStage2
